// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/tour_next_butn_arrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BeginnerGuide_item_title__dMJ2N {
    color: #111111;
    font-size: 20px;
    font-weight: bold;
}

.BeginnerGuide_item_description__zMSOj {
    color: #111111;
    font-size: 14px;
}

.BeginnerGuide_item_indicators__xU5Ye {
    display: flex;
    margin-bottom: 12px;
}

.BeginnerGuide_item_indicators_circle__CKoMQ {
    width: 8px;
    height: 8px;
    border-radius: 100%;
    margin-right: 6px;
    background-color: #dcdee6;
    cursor: pointer;
}

.BeginnerGuide_item_indicators_circle_active__PifwP {
    background-color: #17a8b5;
}

.custom_tour.ant-tour {
    width: 288px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25) ;
    /* transition: all 0.3s; */
}

.custom_tour.ant-tour.custom_tour_tour1 {
    animation: BeginnerGuide_fadeInModal1__4fiPq 1.0s ease-in-out forwards;
}

.custom_tour.ant-tour.custom_tour_tour2 {
    animation: BeginnerGuide_fadeInModal2__tw2EO 1.0s ease-in-out forwards;
}

.custom_tour.ant-tour.custom_tour_tour3 {
    animation: BeginnerGuide_fadeInModal3__0Gk9e 1.0s ease-in-out forwards;
}

.custom_tour.ant-tour.custom_tour_tour4 {
    animation: BeginnerGuide_fadeInModal4__S5eqA 1.0s ease-in-out forwards;
}

.custom_tour.ant-tour.custom_tour_tour5 {
    animation: BeginnerGuide_fadeInModal5__wfM5J 1.0s ease-in-out forwards;
}

.custom_tour.ant-tour.custom_tour_tour6 {
    animation: BeginnerGuide_fadeInModal6__ifapU 1.0s ease-in-out forwards;
}

@keyframes BeginnerGuide_fadeInModal1__4fiPq {
    0% {
        opacity: 0; /* 初始状态为完全透明 */
    }
    100% {
        opacity: 1; /* 结束状态为完全不透明 */
    }
}

@keyframes BeginnerGuide_fadeInModal2__tw2EO {
    0% { opacity: 0; }
    100% { opacity: 1; }
}

@keyframes BeginnerGuide_fadeInModal3__0Gk9e {
    0% { opacity: 0; }
    100% { opacity: 1; }
}

@keyframes BeginnerGuide_fadeInModal4__S5eqA {
    0% { opacity: 0; }
    100% { opacity: 1; }
}

@keyframes BeginnerGuide_fadeInModal5__wfM5J {
    0% { opacity: 0; }
    100% { opacity: 1; }
}

@keyframes BeginnerGuide_fadeInModal6__ifapU {
    0% { opacity: 0; }
    100% { opacity: 1; }
}

.custom_tour.ant-tour .ant-tour-inner {
    padding: 16px 24px 12px !important;
}

.custom_tour.ant-tour .ant-tour-header,
.custom_tour.ant-tour .ant-tour-description {
    padding: 0;
}

.custom_tour.ant-tour .ant-tour-header {
    margin-bottom: 16px;
}

.custom_tour.ant-tour .ant-tour-description {
    margin-bottom: 24px;
}

.custom_tour.ant-tour .ant-tour-footer {
    display: flex;
    flex-direction: column;
    padding: 0;
}

.custom_tour.ant-tour .ant-tour-buttons {
    width: 100%;
    height: 38px;
    margin: 0;
}

.custom_tour.ant-tour .ant-tour-buttons .ant-btn {
    background-color: transparent;
}

.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_box,
.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    margin-inline-start: 0 !important;
    box-shadow: none;
    transition: background 0.5s;
}
/*
:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_box) {
    background: url('../../../../statics/tour_next_butn.png') no-repeat center / 100% 100%;
}

:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box) {
    background: url('../../../../statics/update_done_butn.png') no-repeat center / 100% 100%;
}

:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box::before) {
    content: "";
    background: url('../../../../statics/update_done_butn_hover.png') no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box::after) {
    content: "";
    background: url('../../../../statics/update_done_butn_active.png') no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box:hover) {
    background: url('../../../../statics/update_done_butn_hover.png') no-repeat center / 100% 100%;
}

:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box:active) {
    background: url('../../../../statics/update_done_butn_active.png') no-repeat center / 100% 100%;
} */

.BeginnerGuide_next_butn__qu78b {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.BeginnerGuide_next_butn_text__w0bWi {
    letter-spacing: 0;
}

.BeginnerGuide_next_butn_icon__Uf3KL {
    width: 20px;
    height: 20px;
    margin-left: 10px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
}

.custom_tour.ant-tour .ant-btn,
.custom_tour.ant-tour .ant-wave,
.custom_tour.ant-tour .ant-wave-motion-appear {
    animation: none !important;
    transition: none;
}

.custom_tour .ant-tour-placeholder-animated {
    rx: 6px;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/BeginnerGuide/index.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,6CAA6C;IAC7C,0BAA0B;AAC9B;;AAEA;IACI,sEAAiD;AACrD;;AAEA;IACI,sEAAiD;AACrD;;AAEA;IACI,sEAAiD;AACrD;;AAEA;IACI,sEAAiD;AACrD;;AAEA;IACI,sEAAiD;AACrD;;AAEA;IACI,sEAAiD;AACrD;;AAEA;IACI;QACI,UAAU,EAAE,cAAc;IAC9B;IACA;QACI,UAAU,EAAE,eAAe;IAC/B;AACJ;;AAEA;IACI,KAAK,UAAU,EAAE;IACjB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,KAAK,UAAU,EAAE;IACjB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,KAAK,UAAU,EAAE;IACjB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,KAAK,UAAU,EAAE;IACjB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,KAAK,UAAU,EAAE;IACjB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iCAAiC;IACjC,gBAAgB;IAChB,2BAA2B;AAC/B;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmCG;;AAEH;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gFAA4F;AAChG;;AAEA;;;IAGI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,OAAO;AACX","sourcesContent":[".item_title {\n    color: #111111;\n    font-size: 20px;\n    font-weight: bold;\n}\n\n.item_description {\n    color: #111111;\n    font-size: 14px;\n}\n\n.item_indicators {\n    display: flex;\n    margin-bottom: 12px;\n}\n\n.item_indicators_circle {\n    width: 8px;\n    height: 8px;\n    border-radius: 100%;\n    margin-right: 6px;\n    background-color: #dcdee6;\n    cursor: pointer;\n}\n\n.item_indicators_circle_active {\n    background-color: #17a8b5;\n}\n\n:global(.custom_tour.ant-tour) {\n    width: 288px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25) ;\n    /* transition: all 0.3s; */\n}\n\n:global(.custom_tour.ant-tour.custom_tour_tour1) {\n    animation: fadeInModal1 1.0s ease-in-out forwards;\n}\n\n:global(.custom_tour.ant-tour.custom_tour_tour2) {\n    animation: fadeInModal2 1.0s ease-in-out forwards;\n}\n\n:global(.custom_tour.ant-tour.custom_tour_tour3) {\n    animation: fadeInModal3 1.0s ease-in-out forwards;\n}\n\n:global(.custom_tour.ant-tour.custom_tour_tour4) {\n    animation: fadeInModal4 1.0s ease-in-out forwards;\n}\n\n:global(.custom_tour.ant-tour.custom_tour_tour5) {\n    animation: fadeInModal5 1.0s ease-in-out forwards;\n}\n\n:global(.custom_tour.ant-tour.custom_tour_tour6) {\n    animation: fadeInModal6 1.0s ease-in-out forwards;\n}\n\n@keyframes fadeInModal1 {\n    0% {\n        opacity: 0; /* 初始状态为完全透明 */\n    }\n    100% {\n        opacity: 1; /* 结束状态为完全不透明 */\n    }\n}\n\n@keyframes fadeInModal2 {\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n}\n\n@keyframes fadeInModal3 {\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n}\n\n@keyframes fadeInModal4 {\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n}\n\n@keyframes fadeInModal5 {\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n}\n\n@keyframes fadeInModal6 {\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n}\n\n:global(.custom_tour.ant-tour .ant-tour-inner) {\n    padding: 16px 24px 12px !important;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-header),\n:global(.custom_tour.ant-tour .ant-tour-description) {\n    padding: 0;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-header) {\n    margin-bottom: 16px;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-description) {\n    margin-bottom: 24px;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-footer) {\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-buttons) {\n    width: 100%;\n    height: 38px;\n    margin: 0;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-buttons .ant-btn) {\n    background-color: transparent;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_box),\n:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box) {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    margin-inline-start: 0 !important;\n    box-shadow: none;\n    transition: background 0.5s;\n}\n/*\n:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_box) {\n    background: url('../../../../statics/tour_next_butn.png') no-repeat center / 100% 100%;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box) {\n    background: url('../../../../statics/update_done_butn.png') no-repeat center / 100% 100%;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box::before) {\n    content: \"\";\n    background: url('../../../../statics/update_done_butn_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box::after) {\n    content: \"\";\n    background: url('../../../../statics/update_done_butn_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box:hover) {\n    background: url('../../../../statics/update_done_butn_hover.png') no-repeat center / 100% 100%;\n}\n\n:global(.custom_tour.ant-tour .ant-tour-buttons .custom_next_butn_done_box:active) {\n    background: url('../../../../statics/update_done_butn_active.png') no-repeat center / 100% 100%;\n} */\n\n.next_butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.next_butn_text {\n    letter-spacing: 0;\n}\n\n.next_butn_icon {\n    width: 20px;\n    height: 20px;\n    margin-left: 10px;\n    background: url('../../../../statics/tour_next_butn_arrow.png') no-repeat center / 100% 100%;\n}\n\n:global(.custom_tour.ant-tour .ant-btn),\n:global(.custom_tour.ant-tour .ant-wave),\n:global(.custom_tour.ant-tour .ant-wave-motion-appear) {\n    animation: none !important;\n    transition: none;\n}\n\n:global(.custom_tour .ant-tour-placeholder-animated) {\n    rx: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item_title": `BeginnerGuide_item_title__dMJ2N`,
	"item_description": `BeginnerGuide_item_description__zMSOj`,
	"item_indicators": `BeginnerGuide_item_indicators__xU5Ye`,
	"item_indicators_circle": `BeginnerGuide_item_indicators_circle__CKoMQ`,
	"item_indicators_circle_active": `BeginnerGuide_item_indicators_circle_active__PifwP`,
	"fadeInModal1": `BeginnerGuide_fadeInModal1__4fiPq`,
	"fadeInModal2": `BeginnerGuide_fadeInModal2__tw2EO`,
	"fadeInModal3": `BeginnerGuide_fadeInModal3__0Gk9e`,
	"fadeInModal4": `BeginnerGuide_fadeInModal4__S5eqA`,
	"fadeInModal5": `BeginnerGuide_fadeInModal5__wfM5J`,
	"fadeInModal6": `BeginnerGuide_fadeInModal6__ifapU`,
	"next_butn": `BeginnerGuide_next_butn__qu78b`,
	"next_butn_text": `BeginnerGuide_next_butn_text__w0bWi`,
	"next_butn_icon": `BeginnerGuide_next_butn_icon__Uf3KL`
};
export default ___CSS_LOADER_EXPORT___;
